export default __webpack_public_path__ + "static/media/soul-salmon.c03d51d0.png";